<template>
    <v-layout>
        <v-container class="pt-2">
            <v-layout row wrap>              
              
              <v-flex xs12 sm6 md4>
                <router-link :to="{ name:'Items'}">
                  <v-card class="white--text main_item main_color" style="text-align:center;color:#FFF!important;">
                    <div class="text-xs-center">
                      <v-icon round class="item_icon">card_giftcard</v-icon>
                    </div>
                    <div class="item">
                      <h1 class="white--text">{{ $t('Items')}}</h1>
                      <h4 class="white--text">{{ $t('Item')}} {{ $t('Quantity')}}: {{total_items}}</h4>
                    </div>
                  </v-card>
                </router-link>
              </v-flex>             

              <v-flex xs12 sm6 md4>
                <router-link :to="{ name:'Sales'}">
                  <v-card class="white--text main_item main_color" style="text-align:center;color:#FFF!important;">
                    <div class="text-xs-center">
                      <v-icon round class="item_icon">add_shopping_cart</v-icon>
                    </div>
                    <div class="item">
                      <h1 class="white--text">{{ $t('Sales')}}</h1>
                      <h4 class="white--text">{{ $t('Sales')}} {{ $t('Today')}} : {{currency}}{{pos_sales_today}}</h4>
                    </div>
                  </v-card>
                </router-link>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <router-link :to="{ name:'Expenses'}">
                  <v-card class="white--text main_item main_color" style="text-align:center;color:#FFF!important;">
                    <div class="text-xs-center">
                      <v-icon round class="item_icon">attach_money</v-icon>
                    </div>
                    <div class="item">
                      <h1 class="white--text">{{ $t('Expense')}}</h1>
                      <h4 class="white--text">{{ $t('Expense')}} {{ $t('Today')}}: {{currency}}{{expense_today}}</h4>
                    </div>
                  </v-card>
                </router-link>
              </v-flex>
                
            </v-layout> 
        </v-container>
    </v-layout>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import firebase from "firebase";
  import moment from 'moment'   
  export default {
    name:'PosHeader',
    components: {
      Navbar
    },
    data(){
      return{
        currency:'',
        search: '',
        pos_sales_today:'',
        number_of_pos_sales:'',
        total_items:'',
        expense_today:'',
      }
    },
    methods:{

        
      
    },
    created(){
        var db = firebase.firestore();

        // Current Currency
        db.collection("settings").doc('config').onSnapshot(doc =>{
          this.currency = doc.data().currency
        })

        // Total POS sales Today
        db.collection('orders')            
        .where("order_type", "==",'POS Customer')
        .where("created_date", "==", moment().format('DD-MM-YYYY'))
        .get()
        .then(snapshot => {
                var totalPosSales = 0;
                snapshot.forEach(doc => {
                    totalPosSales += Number(doc.data().checkout_total)
                })
                this.pos_sales_today = totalPosSales;
        })

        // Total number of POS sales today
            db.collection('orders')            
        .where("order_type", "==",'POS Customer')
        .where("created_date", "==", moment().format('DD-MM-YYYY'))
        .get()
        .then(snapshot => {
                this.number_of_pos_sales = snapshot.size;
        })

         // Total Items
        db.collection('items')
        .get()
        .then(snapshot => {
            this.total_items = snapshot.size;
        })

        // Total Expense Today
        db.collection('expenses').where("expense_date", "==", moment().format('DD-MM-YYYY'))
          .get()
          .then(snapshot => {
                var totalExpense = 0;
                snapshot.forEach(doc => {
                    totalExpense += Number(doc.data().expense_amount)
                })
                this.expense_today = totalExpense;
        })
      
      },
      computed: {
      
      }
  }
</script>

<style scoped>
  .project_item{
    padding:20px;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
  .project_item:hover{
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.39);
	}
  td{
    text-align: center;
  }
  .order_id a{
    text-decoration: underline !important;
    color: black;
  }
  .primary--text {
    color: #E7272D !important;
    caret-color: #E7272D !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/pos/sections/PosHeader.vue